// Mock data for Kaushal website

export const heroData = {
  title: "The Partnership Accord by Kaushal",
  subtitle: "Kaushal - It's a Skill!",
  description: "A modern premarital framework that emphasizes equality, communication, and shared responsibility – essentially your own 'Marital Charter'",
  videoUrl: "https://videos.pexels.com/video-files/8035058/8035058-uhd_2560_1440_25fps.mp4"
};

export const aboutData = {
  title: "Talk through what matters, before it matters.",
  description: "Marriage is a commitment that extends far beyond rituals and celebrations. At Kaushal It's a Skill, we guide couples through essential pre-marital dialogues on finances, career aspirations, family dynamics, and more. With experienced behavioural and interpersonal mediators, we help transform unspoken expectations into clear, informed understandings."
};

export const whyChooseData = {
  title: "Fostering Informed Marriages Built on Clarity and Communication",
  subtitle: "A beautiful wedding may last a day, but a well-structured marriage lasts a lifetime. Through our specialized pre-marital mediation programs, we help couples build a foundation of trust, transparency, and mutual understanding — bridging the emotional, practical, and legal dimensions of marriage.",
  features: [
    {
      id: 1,
      title: "Guided Communication",
      description: "Master the art of meaningful dialogue with structured frameworks that help you navigate complex topics with empathy and clarity.",
      icon: "MessageCircle"
    },
    {
      id: 2,
      title: "Structured Agreements",
      description: "Create a personalized Partnership Accord that documents your shared values, expectations, and commitments for a harmonious future.",
      icon: "FileText"
    }
  ]
};

export const servicesData = [
  {
    id: 1,
    title: "Foundational Agreements",
    subtitle: "Don't Just Plan a Wedding. Design Your Future.",
    description: "Build a solid foundation with clear agreements on finances, roles, and responsibilities. Start your partnership with transparency and mutual understanding.",
    icon: "Building2",
    videoUrl: "https://videos.pexels.com/video-files/7233822/7233822-uhd_2560_1440_25fps.mp4"
  },
  {
    id: 2,
    title: "Constructive Dialogue Toolkit",
    subtitle: "Master the Language of a Lasting Partnership.",
    description: "Learn proven communication strategies, conflict resolution techniques, and emotional intelligence tools to navigate challenges together with grace.",
    icon: "MessagesSquare",
    videoUrl: "https://videos.pexels.com/video-files/5533921/5533921-uhd_2560_1440_25fps.mp4"
  },
  {
    id: 3,
    title: "Family Integration Strategy",
    subtitle: "Two Individuals. Two Families. One Harmonious Future.",
    description: "Navigate the complexities of merging families with structured conversations about boundaries, traditions, and shared expectations.",
    icon: "Users",
    videoUrl: "https://videos.pexels.com/video-files/6893882/6893882-uhd_2560_1440_25fps.mp4"
  }
];

export const packagesData = [
  {
    id: 1,
    name: "Saamanjasya",
    subtitle: "Foundational",
    sessions: 3,
    price: "₹15,000",
    description: "Core clarity on money, roles, and communication; structured takeaways.",
    ideal: "Ideal for couples seeking guided conversations on financial planning, conflict resolution, and family dynamics.",
    features: [
      "3 Guided Sessions (90 mins each)",
      "Financial Planning Framework",
      "Communication Basics",
      "Conflict Resolution Starter Kit",
      "Digital Workbook"
    ],
    popular: false
  },
  {
    id: 2,
    name: "Sammati",
    subtitle: "Consent & Clarity",
    sessions: 5,
    price: "₹28,000",
    description: "Deeper alignment across finances, careers, family dynamics, intimacy & boundaries; draft Partnership Accord.",
    ideal: "Insightful exploration of emotional expectations, conflict management, parenting perspectives, and shared responsibilities.",
    features: [
      "5 Guided Sessions (90 mins each)",
      "Draft Partnership Accord",
      "Financial Strategy Deep Dive",
      "Intimacy & Boundaries Module",
      "Career Alignment Framework",
      "Family Dynamics Playbook"
    ],
    popular: true
  },
  {
    id: 3,
    name: "Sankalp",
    subtitle: "Commitment & Alignment",
    sessions: 8,
    price: "₹45,000",
    description: "Comprehensive partnership readiness and alignment journey integrating emotional intelligence, financial strategy, conflict resilience, and long-term planning.",
    ideal: "Ideal for couples preparing for marriage, cohabitation, or long-term partnership who want to translate shared values into enduring practices.",
    features: [
      "8 Comprehensive Sessions (90 mins each)",
      "Signed Partnership Accord",
      "Complete Financial Strategy",
      "Emotional Intelligence Training",
      "Conflict Resilience Toolkit",
      "Long-term Planning Framework",
      "3-Month Follow-up Session",
      "Lifetime Access to Resources"
    ],
    popular: false
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Amrita & Rohan",
    role: "Client",
    content: "Kaushal helped us discuss topics we never even considered. We feel more confident stepping into marriage.",
    rating: 5,
    image: "https://images.pexels.com/photos/2788488/pexels-photo-2788488.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Meera & Karan",
    role: "Client",
    content: "The pre-marital mediation sessions brought us closer. We now have a clear plan for finances and family planning.",
    rating: 5,
    image: "https://images.pexels.com/photos/1024311/pexels-photo-1024311.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "Aryan & Neha",
    role: "Client",
    content: "Kaushal taught us how to handle conflicts without letting them fester. It's been a game-changer for our relationship.",
    rating: 5,
    image: "https://images.pexels.com/photos/3585325/pexels-photo-3585325.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop"
  },
  {
    id: 4,
    name: "Priya & Aditya",
    role: "Client",
    content: "The Partnership Accord has become our reference guide. It's helped us navigate the first year of marriage with confidence and clarity.",
    rating: 5,
    image: "https://images.pexels.com/photos/1415131/pexels-photo-1415131.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop"
  }
];

export const faqData = [
  {
    id: 1,
    question: "What does 'Kaushal - it's a skill' really mean?",
    answer: "Kaushal translates to 'skill' — we believe partnership is not luck, but a practiced skill. Our sessions equip couples with emotional, financial, and relational tools to build sustainable harmony through conscious practice."
  },
  {
    id: 2,
    question: "Is Kaushal therapy or counseling?",
    answer: "Not exactly. Kaushal is a guided facilitation space, not a therapeutic or diagnostic one. Our facilitators combine behavioural frameworks, emotional intelligence tools, and structured discussions — so you learn to communicate, decide, and align better as partners."
  },
  {
    id: 3,
    question: "How are the sessions structured?",
    answer: "Each plan (3, 5, or 8 sessions) follows a guided conversation model with exercises, reflective prompts, and take-home frameworks. Every couple gets a dedicated facilitator who tracks their journey across sessions."
  },
  {
    id: 4,
    question: "Are sessions confidential?",
    answer: "Absolutely. All discussions and written materials remain private between the couple and facilitator. No recordings or data are shared externally."
  },
  {
    id: 5,
    question: "Can we attend online?",
    answer: "Yes, all sessions are offered virtually or in-person. Many couples prefer online for convenience."
  },
  {
    id: 6,
    question: "What is a 'Partnership Accord'?",
    answer: "It's a personalized document co-created through your sessions summarizing your agreements on communication, money, roles, conflict management, intimacy, and family boundaries. It's your shared blueprint for daily life."
  },
  {
    id: 7,
    question: "What's the difference between the 3, 5, and 8-session plans?",
    answer: "• Saamanjasya (3 sessions): builds foundational clarity. • Sammati (5 sessions): brings emotional and practical depth. • Sankalp (8 sessions): creates full readiness and a signed Partnership Accord with check-ins."
  },
  {
    id: 8,
    question: "Who are these programs for?",
    answer: "Couples at any stage - dating seriously, engaged, newly married, or cohabiting; who want to build clarity before commitment or reset and realign after."
  },
  {
    id: 9,
    question: "What kind of results do couples see?",
    answer: "Most couples report: • Fewer recurring arguments (within 4–6 weeks) • Better conversations around money and family • Greater emotional safety and mutual respect • A tangible sense of teamwork in daily life"
  },
  {
    id: 10,
    question: "Can we customize our plan?",
    answer: "Yes, you can blend modules or extend to follow-up sessions depending on your readiness stage."
  }
];

export const teamData = [
  {
    id: 1,
    name: "Dr. Anjali Sharma",
    role: "Lead Facilitator & Behavioral Expert",
    description: "15+ years in relationship counseling and conflict resolution",
    image: "https://images.pexels.com/photos/1181686/pexels-photo-1181686.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop"
  },
  {
    id: 2,
    name: "Rajiv Mehta",
    role: "Financial Planning Specialist",
    description: "Certified Financial Planner with expertise in couple's finances",
    image: "https://images.pexels.com/photos/1222271/pexels-photo-1222271.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop"
  },
  {
    id: 3,
    name: "Priya Desai",
    role: "Family Dynamics Mediator",
    description: "Expert in intercultural relationships and family integration",
    image: "https://images.pexels.com/photos/1181690/pexels-photo-1181690.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop"
  },
  {
    id: 4,
    name: "Vikram Patel",
    role: "Communication Coach",
    description: "Specialized in emotional intelligence and effective dialogue",
    image: "https://images.pexels.com/photos/1516680/pexels-photo-1516680.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop"
  }
];